// Presentation metadata only. Calculations remain in the shared API.
const config = Object.freeze({
  endpoint: '/api/calculators/pension-shortfall/calculate',
  fields: ['currentAge', 'retirementAge', 'currentFundValue', 'grossMonthlyPremium', 'annualGrowthRatePercent'],
  example: [40, 60, 100000, 100, 5],
  subject: 'projection', initialMessage: 'Enter your pension details to see the projection.',
  validationMessage: 'Enter a finite numeric value.',
  successMessage: 'Projection calculated using the workbook method.',
  outputLabels: { yearsToRetirement: 'Years until retirement', annualGrossContribution: 'Annual contribution', projectedRetirementFund: 'Projected fund', illustrativeAnnualIncome: 'Annual income' }
});
export default config;
